module.exports = __webpack_public_path__ + "static/img/kapian11.bf607cad.png";